import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import * as Types from 'types'
import certified from 'images/certified.svg'
import {
  SearchResultContactLink,
  HighlightText,
  OpenToPartnershipsIndicator,
  BadgeIndicator,
} from 'components'
import { serializeLocation, toAddressString } from 'utils'
import { get, uniq, startCase } from 'lodash'
import locationImg from 'images/map/dashboards/location.svg'
import emailImg from 'images/map/dashboards/email.svg'

const propTypes = {
  partner: Types.partnerSearchData.isRequired,
  schoolYearFilter: PropTypes.number,
}

const defaultProps = {}

function getPartnerAddress(partner, addressFields = ['state', 'zip']) {
  const address = partner?.address || {}
  if (!address) return null
  const selectedAddressFields = {}
  addressFields.forEach((field) => {
    if (address[field] !== undefined) {
      selectedAddressFields[field] = address[field]
    }
  })
  return toAddressString(selectedAddressFields)
}

function PartnerSearchResult({
  partner,
  partner: {
    id,
    name,
    email,
    disciplines,
    contact,
    isCertified,
    highlights,
    openToPartnerships,
    badges,
  },
  schoolYearFilter,
}) {
  const partnerUrl = `/partners/${id}`
  const artistUrl = `/teaching-artist/${id}`
  const type = partner.type || 'organization'
  const address =
    type === 'teaching_artist'
      ? getPartnerAddress(partner)
      : get(serializeLocation(partner.type, partner), 'address')
  const anyHighlights = highlights && Object.keys(highlights).length > 0
  const mappedDisciplines = uniq(disciplines.map((d) => startCase(d.name)))
    .sort()
    .join(', ')
  return (
    <div>
      <div className="text-block">
        <h3 data-cy="search-result-name">
          <Link
            to={`${
              type === 'organization' ? partnerUrl : artistUrl
            }?year=${schoolYearFilter}`}
          >
            {name}
          </Link>
        </h3>
        <ul className="contact-details">
          {address && (
            <li>
              <img src={locationImg} alt="" />
              {address}
            </li>
          )}
          {contact && contact.email && (
            <li>
              <img src={emailImg} alt="" />
              {contact.email}
            </li>
          )}
          {email && (
            <li>
              <img src={emailImg} alt="" />
              {email}
            </li>
          )}
        </ul>
        {mappedDisciplines.length > 0 && <p>Provides: {mappedDisciplines}</p>}
      </div>
      <div className="result-details">
        {openToPartnerships && <OpenToPartnershipsIndicator />}
        {/* Dynamic badges from the server */}
        {(badges || []).map((badge) => (
          <BadgeIndicator
            key={`badge-${badge.id || badge.name}`}
            iconUrl={badge.iconUrl}
            label={badge.questionText || badge.name}
            size={33}
          />
        ))}
        {contact && (
          <SearchResultContactLink
            email={contact.email}
            resultName={name}
            contactName={contact.firstName}
          >
            <button
              aria-label={`Contact ${name}`}
              className="button-default-outline"
            >
              Contact Partner
            </button>
          </SearchResultContactLink>
        )}
        {email && (
          <SearchResultContactLink
            email={email}
            resultName={name}
            contactName={name}
          >
            <button
              aria-label={`Contact ${name}`}
              className="button-default-outline"
            >
              Contact Teaching Artist
            </button>
          </SearchResultContactLink>
        )}
        {isCertified && (
          <img className="certified" src={certified} alt="Certified Logo" />
        )}
      </div>
      <div>
        {anyHighlights && (
          <ul className="matched-terms">
            {Object.keys(highlights || {}).map((key, i) => {
              return (
                <HighlightText
                  key={i}
                  highlightName={key}
                  highlightValue={highlights[key]}
                />
              )
            })}
          </ul>
        )}
      </div>
    </div>
  )
}

PartnerSearchResult.propTypes = propTypes

PartnerSearchResult.defaultProps = defaultProps

export default PartnerSearchResult
